const { fs } = require('memfs');

module.exports = fs;
